import { useEffect } from 'react'
import { useSettings } from './useSettings'
import { loadFont } from '@/lib/font-loader'

export function useFontLoader() {
  const { settings } = useSettings()

  useEffect(() => {
    // Always load Nunito (UI font)
    Promise.all([
      loadFont('Nunito', 400, '/fonts/nunito/nunito-400.woff2'),
      loadFont('Nunito', 500, '/fonts/nunito/nunito-500.woff2'),
      loadFont('Nunito', 600, '/fonts/nunito/nunito-600.woff2')
    ]).catch(console.error)
  }, [])

  useEffect(() => {
    // Load selected Chinese font
    if (settings.chineseFont === 'lxgw-wenkai-tc') {
      loadFont(
        'LXGW WenKai TC',
        400,
        '/fonts/lxgw-wenkai-tc/lxgw-wenkai-tc-400.woff2'
      ).catch(console.error)
    } else if (settings.chineseFont === 'noto-sans-tc') {
      loadFont(
        'Noto Sans TC',
        400,
        '/fonts/noto-sans-tc/noto-sans-tc-400.woff2'
      ).catch(console.error)
    } else if (settings.chineseFont === 'noto-sans-sc') {
      loadFont(
        'Noto Sans SC',
        400,
        '/fonts/noto-sans-sc/noto-sans-sc-400.woff2'
      ).catch(console.error)
    }
  }, [settings.chineseFont])
}
